import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Users, UserCheck, Megaphone, Trophy, Image, ArrowRight, Plus, UserPlus, Clock } from "lucide-react";
import { api } from "@/lib/api";

const cards = [
  { key: "total_resellers", label: "Total Resellers", Icon: Users },
  { key: "active_resellers", label: "Active Resellers", Icon: UserCheck },
  { key: "total_notices", label: "Total Notices", Icon: Megaphone },
  { key: "published_rankings", label: "Published Rankings", Icon: Trophy },
  { key: "total_banners", label: "Banners / Images", Icon: Image },
  { key: "total_applications", label: "Host Applications", Icon: UserPlus },
  { key: "pending_applications", label: "Pending Applications", Icon: Clock },
];

const quick = [
  { to: "/admin/resellers", label: "Manage Resellers", Icon: Users },
  { to: "/admin/rankings", label: "Update Rankings", Icon: Trophy },
  { to: "/admin/notices", label: "Post a Notice", Icon: Megaphone },
  { to: "/admin/host-applications", label: "Host Applications", Icon: UserPlus },
];

export default function Dashboard() {
  const { data: stats } = useQuery({ queryKey: ["admin-stats"], queryFn: async () => (await api.get("/admin/stats")).data });

  return (
    <div>
      <h1 className="font-display text-3xl font-bold text-white">Dashboard</h1>
      <p className="mt-1 text-slate-400">Overview of your Golden Live website content.</p>

      <div className="mt-8 grid grid-cols-2 gap-4 lg:grid-cols-5">
        {cards.map(({ key, label, Icon }) => (
          <div key={key} className="card-surface rounded-2xl p-5" data-testid={`stat-${key}`}>
            <Icon className="h-6 w-6 text-gold" />
            <p className="mt-3 font-display text-3xl font-bold text-white">{stats?.[key] ?? "—"}</p>
            <p className="mt-1 text-xs text-slate-400">{label}</p>
          </div>
        ))}
      </div>

      <h2 className="mt-10 text-lg font-bold text-white">Quick Actions</h2>
      <div className="mt-4 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {quick.map(({ to, label, Icon }) => (
          <Link key={to} to={to} className="card-surface group flex items-center justify-between rounded-2xl p-5 transition-all hover:-translate-y-0.5">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-gold/10">
                <Icon className="h-5 w-5 text-gold" />
              </span>
              <span className="text-sm font-semibold text-slate-100">{label}</span>
            </div>
            <ArrowRight className="h-4 w-4 text-slate-500 transition-transform group-hover:translate-x-1" />
          </Link>
        ))}
      </div>
    </div>
  );
}
